import script from "./ReminderDefinitionList.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderDefinitionList.vue?vue&type=script&setup=true&lang=js"

import "./ReminderDefinitionList.vue?vue&type=style&index=0&id=fae3809c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fae3809c"]])

export default __exports__